import {
  BrandingConfig,
  PageConfig,
  PageKey,
} from "@apis:ui_branding/ui_branding";

import {
  DEFAULT_BACKGROUND,
  DEFAULT_PRIMARY,
  DEFAULT_SECONDARY,
  DEFAULT_SIDEBAR,
  PAGE_KEYS,
} from "./constants";

interface FormDataWithPages {
  logoBase64: string;
  primaryColor: string;
  secondaryColor: string;
  sidebarColor: string;
  backgroundColor: string;
  browserTitle: string;
  faviconUrl: string;
  faviconBase64: string;
  pages: Record<PageKey, PageConfig>;
}

export const formValuesFromConfig = (
  config: BrandingConfig | null | undefined,
): FormDataWithPages => ({
  logoBase64: config?.logoBase64 ?? "",
  primaryColor: config?.primaryColor ?? DEFAULT_PRIMARY,
  secondaryColor: config?.secondaryColor ?? DEFAULT_SECONDARY,
  sidebarColor: config?.sidebarColor ?? DEFAULT_SIDEBAR,
  backgroundColor: config?.backgroundColor ?? DEFAULT_BACKGROUND,
  browserTitle: config?.browserTitle ?? "",
  faviconUrl: config?.faviconUrl ?? "",
  faviconBase64: config?.faviconBase64 ?? "",
  pages: PAGE_KEYS.reduce(
    (acc, page) => ({
      ...acc,
      [page]: {
        iconKey: config?.pages?.[page]?.iconKey ?? null,
        customIconSvg: config?.pages?.[page]?.customIconSvg ?? null,
        tooltip: config?.pages?.[page]?.tooltip ?? null,
        title: config?.pages?.[page]?.title ?? null,
        description: config?.pages?.[page]?.description ?? null,
      },
    }),
    {} as Record<PageKey, PageConfig>,
  ),
});

export const buildBrandingConfig = (
  data: FormDataWithPages,
): BrandingConfig => {
  const pagesWithValues = Object.fromEntries(
    Object.entries(data.pages).filter(
      ([, config]) =>
        config.iconKey ||
        config.customIconSvg ||
        config.tooltip ||
        config.title ||
        config.description,
    ),
  );

  return {
    logoBase64: data.logoBase64 || null,
    primaryColor: data.primaryColor,
    secondaryColor: data.secondaryColor,
    sidebarColor: data.sidebarColor,
    backgroundColor: data.backgroundColor,
    browserTitle: data.browserTitle || null,
    faviconUrl: data.faviconUrl || null,
    faviconBase64: data.faviconBase64 || null,
    pages: Object.keys(pagesWithValues).length > 0 ? pagesWithValues : null,
  };
};
